import { render, staticRenderFns } from "./UITrendingStockWidget.vue?vue&type=template&id=d76fdddc"
import script from "./UITrendingStockWidget.vue?vue&type=script&lang=js"
export * from "./UITrendingStockWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/skade-pwa/components/ui/atom/Img.vue').default,ChangePercent: require('/skade-pwa/components/ui/atom/ChangePercent.vue').default})
